import { IpadConfigList } from '@/features/ipad-configs';

const IpadConfigurationPage = () => {
  return <IpadConfigList />;
};

export default IpadConfigurationPage;
